import React from "react";

const LoadingSpinner = ({ size = "medium", text = "Se incarca..." }) => {
  const sizes = {
    small: { width: "30px", height: "30px" },
    medium: { width: "50px", height: "50px" },
    large: { width: "80px", height: "80px" },
  };

  const spinnerStyle = {
    ...sizes[size],
    border: "4px solid #f3f3f3",
    borderTop: "4px solid #007bff",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
    margin: "20px auto",
    display: "block",
  };

  return (
    <div
      style={{
        textAlign: "center",
        padding: "40px",
        backgroundColor: "#f8f9fa",
        borderRadius: "8px",
        margin: "20px 0",
      }}
    >
      <div style={spinnerStyle}></div>
      <p
        style={{
          marginTop: "15px",
          color: "#666",
          fontSize: "16px",
          fontStyle: "italic",
        }}
      >
        {text}
      </p>

      <style jsx>{`
        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </div>
  );
};

export default LoadingSpinner;
